import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  content: PropTypes.shape({
    title: PropTypes.string,
    cancel: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
    confirmButtonName: PropTypes.string,
    cancelButtonName: PropTypes.string,
  }),
};

export default class CustomModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.isOpen,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      isOpen: newProps.isOpen,
    });
  }

  cancelButtonName() {
    let name = 'Cancel';

    if (this.props.content.cancelButtonName) {
      name = this.props.content.cancelButtonName;
    }

    return name;
  }

  confirmButtonName() {
    let name = 'Confirm';

    if (this.props.content.confirmButtonName) {
      name = this.props.content.confirmButtonName;
    }

    return name;
  }

  render() {
    let classes = 'custom-modal wrapper';

    if (this.props.className) {
      classes += ` ${this.props.className}`;
    }

    const render = this.props.content;
    if (render) {
      return (
        <Modal isOpen={this.state.isOpen} className={classes} contentLabel={this.props.content.title}>
          <div>
            <h3>{render.title}</h3>
          </div>
          <div className="modal-body">{render.body}</div>
          <div className="modal-controls">
            <button className="modal-cancel rec-button-tertiary" onClick={this.props.content.cancel}>
              {this.cancelButtonName()}
            </button>
            <button className="modal-confirm rec-button-primary" onClick={this.props.content.confirm}>
              {this.confirmButtonName()}
            </button>
          </div>
        </Modal>
      );
    }
    return (
      <Modal isOpen={this.state.isOpen} className={classes} contentLabel="No Content Modal">
        <div className="modal-body empty-alert">{`The 'content' prop for this modal is undefined.`}</div>
        <div className="modal-controls">
          <button
            className="modal-cancel"
            onClick={() =>
              this.setState({
                isOpen: false,
              })
            }
          >
            Cancel
          </button>
        </div>
      </Modal>
    );
  }
}

Modal.setAppElement('#recApp');

CustomModal.propTypes = propTypes;
